import Vue from 'vue';
import VueI18n from 'vue-i18n';
import translations from './translations';
import moment from 'moment';

Vue.use(VueI18n);

function transformTranslations(translations) {
  const result = {
    en: {}, // Initialize English by default
    ru: {}, // Initialize Russian
    es: {}, // Initialize Spanish
    pt: {}, // Initialize Portuguese
    de: {}  // Initialize German
  };

  Object.keys(translations).forEach(key => {
    if (typeof translations[key] === 'object') {
      // This key has language-specific translations
      Object.keys(translations[key]).forEach(lang => {
        if (result[lang]) {
          result[lang][key] = translations[key][lang];
        }
      });

      // Ensure English fallback for all languages
      Object.keys(result).forEach(lang => {
        if (!result[lang][key] && translations[key]['en']) {
          result[lang][key] = translations[key]['en'];
        }
      });
    } else {
      // This key should be used as-is for all languages
      const value = translations[key];
      Object.keys(result).forEach(lang => {
        result[lang][key] = value;
      });
    }
  });
  return result;
}

// Get the browser's language
function getBrowserLanguage() {
  const browserLang = navigator.language.split('-')[0];
  const supportedLanguages = ['en', 'ru', 'es', 'pt', 'de'];
  return supportedLanguages.includes(browserLang) ? browserLang : 'en';
}

// Get the preferred language in this order:
// 1. localStorage setting
// 2. lucmus.ru — для пользователей из РФ: русский (язык браузера не смотрим)
const savedLocale = localStorage.getItem('userLanguage');
const defaultLocale = savedLocale || 'ru';

// Set HTML lang attribute to match the selected locale
document.documentElement.setAttribute('lang', defaultLocale);

const i18nMessages = transformTranslations(translations);

const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'en',
  messages: i18nMessages,
  silentTranslationWarn: true, // Optional: suppress warnings for missing translations
});

// Add method to merge lazy-loaded translations
i18n.mergeLocaleMessage = (locale, messages) => {
  i18n.setLocaleMessage(locale, {
    ...i18n.getLocaleMessage(locale),
    ...messages
  });
};

// Ensure the locale is saved to localStorage
if (!savedLocale) {
  localStorage.setItem('userLanguage', defaultLocale);
}

// Configure moment.js to use the correct locale
const updateMomentLocale = (locale) => {
  // Map i18n locales to moment locales
  const localeMap = {
    'en': 'en',
    'ru': 'ru',
    'es': 'es',
    'pt': 'pt-br',
    'de': 'de'
  };
  
  const momentLocale = localeMap[locale] || 'en';
  moment.locale(momentLocale);
};

// Set initial moment locale
updateMomentLocale(i18n.locale);

// Update moment locale when i18n locale changes
i18n.onBeforeLanguageChange = (newLocale) => {
  updateMomentLocale(newLocale);
};

// Watch for locale changes
if (i18n.vm) {
  i18n.vm.$watch('locale', (newLocale) => {
    updateMomentLocale(newLocale);
  });
}

export default i18n;
